import { rawData } from "../rawData";
import config from "../config.json";

const { dataSettings } = config;
const { uid } = dataSettings;

const getLookupsForItemsInCart = (arrayOfIds) => {
  const filteredToItemsInCart = rawData.filter((d) =>
    arrayOfIds.includes(d[uid])
  );
  const itemsInCartWithLookups = filteredToItemsInCart.filter((d) =>
    Object.keys(d).includes("lookups")
  );

  const lookupMetadata = [];
  for (const item of itemsInCartWithLookups) {
    const { doi, var_name, table_name, lookups } = item;

    for (const lookup of lookups) {
      const { lookup_PV, lookup_PVM } = lookup;
      lookupMetadata.push({ table_name, doi, var_name, lookup_PV, lookup_PVM });
    }
  }

  return lookupMetadata;
};

export { getLookupsForItemsInCart };
